import { useEffect } from 'react';

// Kullanıcının bir soruyu frontend'de doğru/yanlış kontrolüyle deneyebileceği toplam hak sayısı.
// İlk (MAX_FRONTEND_ATTEMPTS - 1) deneme frontend'de kontrol edilir, yanlışsa backend'e istek atılmaz.
// Son denemede (MAX_FRONTEND_ATTEMPTS'inci) cevap kontrol edilmeden doğrudan backend'e gönderilir.
export const MAX_FRONTEND_ATTEMPTS = 3;

const useAttemptTracker = (questionNumber) => {
    const ATTEMPT_KEY = `question_attempt_${questionNumber}`;

    useEffect(() => {
        if (localStorage.getItem(ATTEMPT_KEY) === null) {
            localStorage.setItem(ATTEMPT_KEY, "0");
        }
    }, [ATTEMPT_KEY]);

    const getAttempt = () => parseInt(localStorage.getItem(ATTEMPT_KEY) || "0", 10);

    const registerWrongAttempt = () => {
        localStorage.setItem(ATTEMPT_KEY, String(getAttempt() + 1));
    };

    const clearAttempt = () => {
        localStorage.removeItem(ATTEMPT_KEY);
    };

    return { getAttempt, registerWrongAttempt, clearAttempt };
};

export default useAttemptTracker;
